/**
 * OMR Fiducials Component
 * Renders the 4 registration marks (quadrados pretos) at the corners
 * Used by OpenCV to detect and correct perspective
 */

import React from 'react';
import {
  FIDUCIAL_SIZE_MM,
  FIDUCIAL_POSITION,
} from '../../utils/omr/constants';

const OMRFiducials = () => {
  const fiducials = [
    { key: 'topLeft', ...FIDUCIAL_POSITION.topLeft },
    { key: 'topRight', ...FIDUCIAL_POSITION.topRight },
    { key: 'bottomLeft', ...FIDUCIAL_POSITION.bottomLeft },
    { key: 'bottomRight', ...FIDUCIAL_POSITION.bottomRight },
  ];

  return (
    <>
      {fiducials.map((fiducial) => (
        <div
          key={fiducial.key}
          style={{
            position: 'absolute',
            left: `${fiducial.x}mm`,
            top: `${fiducial.y}mm`,
            width: `${FIDUCIAL_SIZE_MM}mm`,
            height: `${FIDUCIAL_SIZE_MM}mm`,
            backgroundColor: '#000000',
            border: 'none',
          }}
          className="omr-fiducial"
          data-testid={`fiducial-${fiducial.key}`}
        />
      ))}
    </>
  );
};

export default OMRFiducials;
